import React from "react";

import "./Phonetics.css";

export default function Phonetics(props) {
  return (
    <div className="Phonetics">
      {props.phonetics.map(function (phonetic, idx) {
        if (phonetic.text && phonetic.audio) {
          return (
            <div key={idx}>
              <a href={phonetic.audio} target="_blank" rel="noreferrer">
                {phonetic.text}
              </a>{" "}
            </div>
          );
        } else if (phonetic.text) {
          return <div key={idx}>{phonetic.text} </div>;
        } else {
          return null;
        }
      })}
    </div>
  );
}
